import * as firebase from 'firebase';
import { firebaseVar } from '../utility/apiVar'


let config = {
    apiKey: firebaseVar.apiKey,
    authDomain: firebaseVar.authDomain,
    databaseURL: firebaseVar.databaseURL,
    projectId: firebaseVar.projectId,
    storageBucket: firebaseVar.storageBucket,
    messagingSenderId: firebaseVar.messagingSenderId
  };


if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const firebaseAuth = firebase.auth();
export const database = firebase.database();



// WEBPACK FOOTER //
// ./src/firebase/firebase.js